import React from "react";
import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";
import RichContent from "@/components/RichContent";
import usePageContent, { s } from "@/hooks/usePageContent";
import { parseLocaleFromPath } from "@/lib/locale";

export default function Terms() {
  const { locale } = parseLocaleFromPath(useLocation().pathname);
  const { data: page } = usePageContent("terms", locale);
  const sections = [1, 2, 3, 4, 5];

  return (
    <>
      <SEO title={page?.meta_title} description={page?.meta_description} />
      <article className="bg-background grain-bg">
        <div className="max-w-3xl mx-auto px-5 lg:px-10 py-16 lg:py-24">
          <div className="text-[11px] uppercase tracking-[0.3em] text-primary mb-4">{s(page, "eyebrow")}</div>
          <h1 className="font-serif text-5xl text-foreground leading-tight">{s(page, "title")}</h1>
          <p className="mt-4 text-base text-muted-foreground italic">{s(page, "subtitle")}</p>
          <div className="mt-8 wood-divider w-24" />

          <div className="mt-12 space-y-10 text-foreground/85 leading-relaxed" data-testid="terms-body">
            {sections.map((n) => (
              <section key={n}>
                <h2 className="font-serif text-2xl text-foreground mb-3">{s(page, `s${n}_title`)}</h2>
                <p>{s(page, `s${n}_body`)}</p>
              </section>
            ))}
          </div>
        </div>
      </article>
    </>
  );
}
